import React from 'react';
import PrepareDayBadge from './PrepareDayBadge';
import { DailyPlanFormat, PrepPlanBadgeStatus } from 'types';
import PrepareQuestionCard from './PrepareQuestionCard';
import { Img } from 'react-image';

interface Props {
	dailyPlan: DailyPlanFormat[];
}

const DayComponent = ({ dailyPlan }: Props) => {
	return (
		<div className="flex flex-1 flex-col mt-8">
			{dailyPlan.map((day, index) => {
				return (
					<div key={index} className="flex gap-[7px] md:gap-4 ">
						<div className="relative flex flex-col items-center mt-[6px]">
							<Img src={'/assets/prepareBadgeInProgress.svg'} className="w-6 h-6" />
							{index < dailyPlan?.length - 1 ? (
								<div className="absolute h-full border-l-[3px] top-6 border-[#7777E7] border-dashed mx-auto"></div>
							) : null}
						</div>

						<div key={day.day} className="w-full flex flex-col gap-6 pb-[50px] ">
							<div className="relative">
								<PrepareDayBadge day={day.day} status={day.status as PrepPlanBadgeStatus} />
							</div>
							{day?.questions.map(ques => (
								<PrepareQuestionCard key={ques._id} question={ques} status={day.status as PrepPlanBadgeStatus} />
							))}
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default DayComponent;
